import { type Feature, SYSTEM_FEATURES } from "../enums";

export const CLINIC_FLAGS = [
  "onlineBooking",
  "showPrices",
  "requiresApproval",
  "collectPaymentAtBooking",
  "sendReminders",
  "emailNotifications",
  "whatsappNotifications",
] as const;

export type ClinicFlag = (typeof CLINIC_FLAGS)[number];

type FlagCapability = Feature | null;

interface FlagConfigItem {
  id: ClinicFlag;
  capability: FlagCapability;
  dependsOn?: ClinicFlag;
}

export const FLAG_CONFIG: FlagConfigItem[] = [
  { id: "onlineBooking", capability: SYSTEM_FEATURES[0] }, // CALENDAR
  { id: "showPrices", capability: null },
  { id: "requiresApproval", capability: null },
  { id: "sendReminders", capability: SYSTEM_FEATURES[5] }, //"NOTIFICATIONS_EMAIL"
  {
    id: "emailNotifications",
    capability: SYSTEM_FEATURES[5],
    dependsOn: "sendReminders",
  },
  {
    id: "whatsappNotifications",
    capability: SYSTEM_FEATURES[6],
    dependsOn: "sendReminders",
  }, //"NOTIFICATIONS_WHATSAPP"
  { id: "collectPaymentAtBooking", capability: SYSTEM_FEATURES[2] }, //"INVOICING"
] as const;
